import React from "react";
import { InsightType } from "../../pages/compose/ScheduleReviewPage";

interface InsightTypeCardProps {
  insight: InsightType;
  isSelected: boolean;
  onToggle: () => void;
}

/**
 * InsightTypeCard - Selectable card for insight types
 */
const InsightTypeCard: React.FC<InsightTypeCardProps> = ({
  insight,
  isSelected,
  onToggle,
}) => {
  return (
    <button
      className={`su-insight-type-card ${isSelected ? "selected" : ""}`}
      onClick={onToggle}
    >
      <span className="su-insight-type-title">{insight.title}</span>
      <span className="su-insight-type-description">{insight.description}</span>
    </button>
  );
};

export default InsightTypeCard;


